import { render, staticRenderFns } from "./paginatedreports.vue?vue&type=template&id=505f7448&lang=pug"
import script from "./paginatedreports.vue?vue&type=script&lang=js"
export * from "./paginatedreports.vue?vue&type=script&lang=js"
import style0 from "./paginatedreports.vue?vue&type=style&index=0&id=505f7448&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports